<template>
    <article class="result-card">
        <div class="result-card__image" v-if="!hideImage">
            <thumbnail-image :photo-id="resultItem.Image.Id" v-if="resultItem.Image"></thumbnail-image>
        </div>
        <div class="result-card__inner flow">
            <div class="result-card__header">
                <h3 class="result-card__title" :id="'search-list-item-' + resultItem.Id">{{resultItem.Heading}}</h3>
                <span class="result-card__label" v-if="resultItem.DocType=='report'">Report</span>
                <span class="result-card__label" v-if="resultItem.DocType=='product' || resultItem.Link.Url.indexOf('/support/') === 0">Support</span>
            </div>
            <div class="result-card__content flow max-width-s">
                <result-tags :tag-parents="resultItem.TagParents"></result-tags>

                <time v-if="resultItem.DocType=='report'" :datetime="resultItem.Date.DateTime"><strong>{{formatDate(resultItem.Date.DateTime)}}</strong></time>
                <p>{{truncate(resultItem.Summary)}}</p>
            </div>
            <div class="result-card__footer">
                <a :href="resultItem.Link.Url" class="btn btn-green" v-if="resultItem.Link" :aria-labelledby="'search-list-item-' + resultItem.Id">
                    Find out more
                </a>
                <profile-actions 
                    :page-id="resultItem.Id.toString()"
                    :heading="resultItem.Heading"
                    v-if="resultItem.DocType=='event'
                    || resultItem.DocType=='newsArticle'
                    || resultItem.DocType=='gateway'
                    || resultItem.DocType=='report'
                    || resultItem.DocType=='product'
                    || resultItem.DocType=='property'">
                </profile-actions>
            </div>
        </div>
    </article>
</template>

<script>
    import Globals from '@/globals.js'
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'
    import { truncate } from '@/utils/strings.js'
    import { format, toDate } from '@/utils/date.js'
    import ResultTags from '@/components/SiteSearch/result-tags'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage,
            ResultTags
        },

        methods: {
            formatDate(date) {
                return format(toDate(date), Globals.dateFormatUi)
            },
            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            },
            formattedTags(tagParents) {
                const whoYouAre = tagParents.find(tag => tag.Name === 'Who you are:')
                return whoYouAre ? whoYouAre.Children : []
            },
            hasWhoYouAreTags(tagParents) {
                const whoYouAreEl = tagParents.find(tag => tag.Name === 'Who you are:')
                return whoYouAreEl && whoYouAreEl.Children.length > 0
            }
        },

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            },
        }
    }
</script>